import { render } from "./SaleEdit.vue?vue&type=template&id=71de94b8&scoped=true"
import script from "./SaleEdit.vue?vue&type=script&lang=js"
export * from "./SaleEdit.vue?vue&type=script&lang=js"

import "./SaleEdit.vue?vue&type=style&index=0&id=71de94b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71de94b8"]])

export default __exports__